import React, { useState, useEffect } from 'react';
import { Select, message, Typography, Alert } from 'antd';

import { api } from 'api';
import { Teamlist, PageTitle } from 'components';
import { useChangePageTitle } from 'utils/useChangePageTitle';
import { useParams } from "react-router-dom";
import globalStyles from 'styles/globalStyles';

import useScreenSize from "hooks/useScreenSize";
import useUser from "hooks/useUser";

import { getErrorMessage } from 'helpers/feedbackMessageHelper';
import { capitalize } from 'helpers/textHelper';
import PremiumWrapper from 'wrappers/PremiumWrapper';

const { Option, OptGroup } = Select;
const { Paragraph, Title, Text } = Typography;

const MiniLeagueStandings = () => {

  let params = useParams();

  const { userData } = useUser();

  const [{ isTabletOrMobile }] = useScreenSize();

  const [teamlistData, setTeamlistData] = useState([]);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortedValue, setSortedValue] = useState('totalPoints');
  const [miniLeagueData, setMiniLeagueData] = useState(null);

  const changePageTitle = useChangePageTitle();

  const getTeamListData = async () => {
    setLoading(true);
    try {
      const results = await api.team.getMiniLeagueTeamList(params.leagueId);

      let teamList = [];
      let months = [];

      results.data.standings.forEach(team => { 
        let teamForList = team;

        Object.keys(team.monthlyPoints).forEach(month => {
          teamForList[month] = team.monthlyPoints[month];

          if (months.indexOf(month) === -1) {
            months = [...months, month];
          }
        });                    

        teamList = [...teamList, teamForList];
      });

      setMiniLeagueData(results.data.miniLeague);
      setTeamlistData(teamList);
      setMonths(months);
      setLoading(false);
    } catch (error) {
      console.log(error);
      const errorMessage = error.response ? error.response.data.error : 'generic';
      message.error(getErrorMessage(errorMessage));
      setLoading(false);
    }
  };

  function Dropdown() {
    return (
      <Select
          value={sortedValue}
          style={{...globalStyles.dropdownWidth(isTabletOrMobile)}} 
          onChange={(value) => setSortedValue(value)}
          >
          <Option value="totalPoints">Overall Total</Option>
          <Option value="weekPoints">Week Total</Option>
          <OptGroup label="Past Months">
              {months.map(month => 
                  <Option key={month} value={month}>{capitalize(month)}</Option>  
              )}
          </OptGroup>
      </Select>
    )
  }

  useEffect(() => {
    getTeamListData();
    changePageTitle(`${miniLeagueData?.name ?? 'Mini'} League Standings`);
  }, [params.leagueId]);

  return (
    <PremiumWrapper>
      <PageTitle title={miniLeagueData?.name} extra={[<Dropdown key="dropdown" />]} />

      {miniLeagueData?.createdBy === userData?.id && (
        <Paragraph>Share this code to invite others to join this league: <Text code copyable>{miniLeagueData?.joinCode}</Text></Paragraph>
      )}
      

      <Teamlist
        year='current'
        teamlistData={teamlistData}
        isLoading={loading}
        sortedValue={sortedValue}
        months={months}
        />
    </PremiumWrapper>
  )
}

export default MiniLeagueStandings;